import React, { useRef, useState, useContext } from "react";
import { Store } from "../state/state";
import { useObserver } from "mobx-react";
import { toJS } from "mobx";

function ImagePlaceHolder({ style, placeHolderStyle, id }) {
  // let imageUpload = useRef();
  const [file, setFile] = useState();
  const store = useContext(Store);
  const _onChange = (event) => {};

  // const onEventClick = (file) => {
  //   console.log("file :", file.target.files);
  //   reader.onloadend = function () {
  //     preview.src = reader.result;
  //   };

  //   if (file) {
  //     reader.readAsDataURL(file);
  //   } else {
  //     preview.src = "";
  //   }
  // };

  return useObserver(() => (
    <div className={"flex flex-col justify-center m-4 "}>
      <div
        id={id}
        // onClick={() => {
        //   // store.setSelect(id);
        //   console.log("id :", toJS(store.select));
        //   console.log("INFO :", toJS(store.theme.images[id]));
        //   // if (src) {
        //   //   imageUpload.current.click();
        //   //   console.log();
        //   // }
        // }}
        className={
          `${
            !store.theme.images[id].src &&
            store.theme.images[id].visible &&
            "border-dashed border-4 border-gray-500 hover:border-gray-700"
          } cursor-pointer  flex justify-center items-center p-2 ` +
          (store.select === id && "selectColor")
        }
        style={{ ...placeHolderStyle, minWidth: "20px", minHeight: "20px" }}
      >
        <input
          id={"input-" + id}
          type="file"
          alt=""
          // ref={imageUpload}
          className="hidden"
          onChange={_onChange}
          accept=".png,.jpeg,.jpg,.svg"
        />
        {store.theme.images[id].visible &&
          (store.theme.images[id].src ? (
            <img
              id={id}
              src={store.theme.images[id].src}
              style={{
                visibility: store.theme.images[id].src ? "visible" : "hidden",
                // width: "60px",
                height: store.theme.images[id].height + "px",
                width: store.theme.images[id].width + "px",
                opacity: store.theme.images[id].opacity,
                marginTop: store.theme.images[id].marginTop,
                marginRight: store.theme.images[id].marginRight,
                marginLeft: store.theme.images[id].marginLeft,
                marginBottom: store.theme.images[id].marginBottom,
              }}
              // id={id}
            />
          ) : (
            <div
              id={id}
              className="fa fa-image text-gray-600"
              style={{
                visibility: !store.theme.images[id].src ? "visible" : "hidden",
              }}
            ></div>
          ))}

        {/* {imgs ? (
          [...imgs].map((file) => (
            <img src={URL.createObjectURL(file)} className="w-full h-full" />
          ))
        ) : (
          <div className="fa fa-image text-gray-600"></div>
        )} */}

        {/* {imgs && <span>{URL.createObjectURL(file)}</span>} */}
      </div>
    </div>
  ));
}

export default ImagePlaceHolder;
